import React from "react";

import * as Styled from "./PageTitle.styles";

const PageTitle: React.FC = ({ children }) => {
  return <Styled.PageTitleWrap>{children}</Styled.PageTitleWrap>;
};

export default PageTitle;
